<template>
  <form @submit.prevent="submit">
    <dt-modal
      :model-value="showDialog"
      @update:model-value="val => emit('update:showDialog', val)"
    >
      <template #header>
        <h4 class="modal-title">
          {{ confirmTitle }}
        </h4>
      </template>

      <template #body>
        <div class="row">
          <div class="form-group col-md-12">
            <p>{{ confirmQuestion }}</p>
          </div>
        </div>
      </template>

      <template #footer>
        <button
          type="button"
          class="btn btn-default"
          @click="close"
        >
          {{ confirmNoAction }}
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          :class="{ cleverButton: isClever() }"
        >
          {{ confirmAction }}
        </button>
      </template>
    </dt-modal>
  </form>
</template>

<script setup>
import { defineProps } from 'vue'
import DtModal from '@/components/utilities/modal/dt-modal.vue'
import { isClever } from '@/plugins/globals.js'

const props = defineProps({
  showDialog: {
    type: Boolean,
    default: false
  },
  confirmTitle: {
    type: String,
    default: 'Confirm Action'
  },
  confirmNoAction: {
    type: String,
    default: 'Cancel'
  },
  confirmAction: {
    type: String,
    default: 'OK'
  },
})

const emit = defineEmits(['update:showDialog', 'closing', 'proceed'])

function close() {
  emit('closing')
  emit('update:showDialog', false)
}

function submit() {
  emit('proceed', props.showDialog)
}
</script>

<style scoped>
.cleverButton {
  background-color: #EAAA00;
  color: #000000;
}
</style>
